import { normalizeSocialCapValue } from './socialAccountCap';

export const TOP_LEVEL_INTEGRATION_ENTITLEMENT_KEYS: readonly string[] = [
  'petpooja',
  'meta_ads',
  'google_ads',
  'linkedin_ads',
  'tiktok_ads',
  'appointments',
  'zoom',
];

export const isTopLevelIntegrationEntitlementKey = (key?: string | null): boolean =>
  !!key && TOP_LEVEL_INTEGRATION_ENTITLEMENT_KEYS.includes(key);

type UnknownMap = Record<string, unknown> | null | undefined;

export interface IntegrationEntitlementContext {
  hasEntitlements: boolean;
  features: UnknownMap;
  subFeatures: UnknownMap;
  limits?: UnknownMap;
}

const capGrants = (raw: unknown): boolean => {
  const cap = normalizeSocialCapValue(raw);
  if (cap === undefined) return false;
  return cap === -1 || cap > 0;
};

export function isIntegrationEntitled(
  ctx: IntegrationEntitlementContext,
  entitlementKey?: string,
): boolean {
  const { hasEntitlements, features, subFeatures, limits } = ctx;

  if (!hasEntitlements) return true;

  if (isTopLevelIntegrationEntitlementKey(entitlementKey) && features?.[entitlementKey!] === true) {
    return true;
  }

  if (features?.integrations !== true) return false;

  if (!entitlementKey) return true;

  if (isTopLevelIntegrationEntitlementKey(entitlementKey) && entitlementKey !== 'petpooja') {
    const rawTopSub = subFeatures?.[entitlementKey];
    if (rawTopSub !== undefined && rawTopSub !== null) {
      const cap = normalizeSocialCapValue(rawTopSub);
      if (cap !== undefined) return cap === -1 || cap > 0;
    }
    return features?.[entitlementKey] === true;
  }

  const rawSub = subFeatures?.[entitlementKey];
  if (rawSub !== undefined && rawSub !== null) {
    const cap = normalizeSocialCapValue(rawSub);
    if (cap !== undefined) return cap === -1 || cap > 0;
  }

  if (features?.[entitlementKey] === false) return false;
  const rawLimit = limits?.[entitlementKey];
  if (rawLimit !== undefined && rawLimit !== null) {
    const limit = normalizeSocialCapValue(rawLimit);
    if (limit !== undefined) return limit === -1 || limit > 0;
  }
  return true;
}

export function hasAnyEntitledIntegration(ctx: IntegrationEntitlementContext): boolean {
  const { hasEntitlements, features, subFeatures } = ctx;

  if (!hasEntitlements) return true;

  if (TOP_LEVEL_INTEGRATION_ENTITLEMENT_KEYS.some((key) => isIntegrationEntitled(ctx, key))) {
    return true;
  }

  if (features?.integrations !== true) return false;

  if (!subFeatures) return true;

  return Object.values(subFeatures).some(capGrants);
}
